<app-temp-modal-cadastro #modalCadastro modalContentId="modal-cadastro-produtos" (closed)="onClose()"
  [textHeader]="titulo" customClass="modal-xxl">
  
  <template #detalhaItemContainer></template>
</app-temp-modal-cadastro>